import React, { useEffect, useState, useContext } from 'react';
import styled from 'styled-components';
import { useParams } from 'react-router-dom';

import FlowBloodInformationForm from '../components/FlowBloodInformationForm.jsx';
import { ChatContext } from '../contexts/ChatContext';
import i18n from '../i18n';
import useRouting from '../hooks/useRouting';
import { patchStorage, retrieveStorageById } from '../helpers/storeService';
import FlowChatBox from '../components/FlowChatBox';
import { format } from 'date-fns';

const FlowHealthInformation = () => {
  const [defaultValues, setDefaultValues] = useState({});
  const { renderNextRoute } = useRouting();
  const { addQuestion, addAnswer } = useContext(ChatContext);
  const { id, affinity, insuranceType, currentHealth } = useParams();

  useEffect(() => {
    const { data } = retrieveStorageById(id, affinity, insuranceType);
    const { healths } = data;
    if (healths[currentHealth] !== null) {
      setDefaultValues(healths[currentHealth]);
    }
    const question = {
      message: i18n.t('When was your latest blood reading?'),
      slug: 'blood-information',
    };
    addQuestion(question);
  }, []);

  function handleSubmit(values) {
    const {
      DateOfRecentBloodPressureReading,
      BloodPresureResult,
      MedicationTaken,
      MedicalDiseases,
    } = values || {};

    const payload = {
      DateOfRecentBloodPressureReading,
      BloodPresureResult,
      MedicationTaken,
    };
    const answer = {
      message: i18n.t(
        `My most recent reading was on and the result was I take medication`,
        {
          date: format(
            new Date(DateOfRecentBloodPressureReading),
            'dd/MM/yyyy'
          ),
          result: BloodPresureResult,
          medication: MedicationTaken,
        }
      ),
      slug: 'blood-information',
    };

    addAnswer(answer);

    patchStorage({
      payload,
      path: ['healths', [currentHealth]],
      id,
      affinity,
      insuranceType,
    });
    if (MedicalDiseases?.find((item) => item.value === '224')) {
      renderNextRoute(2, { health: currentHealth });
    } else {
      renderNextRoute(1, { health: currentHealth });
    }
  }

  const isMobile = () => {
    if (
      insuranceType === 'allMobile' ||
      insuranceType === 'carMobile' ||
      insuranceType === 'healthMobile' ||
      insuranceType === 'homeMobile'
    ) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <SplitContainer>
      {!isMobile() && <FlowChatBox />}
      <RightSplit>
        <FlowBloodInformationForm
          handleFormValues={handleSubmit}
          defaultValues={
            defaultValues.health ? defaultValues.health : defaultValues
          }
        />
      </RightSplit>
    </SplitContainer>
  );
};

const SplitContainer = styled.div`
  display: grid;
  grid-template-columns: 50% 50%;
  width: 100%;
  @media (max-width: 768px) {
    display: flex;
  }
`;

const RightSplit = styled.div`
  padding-left: 4rem;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media (max-width: 768px) {
    padding: 1rem;
    width: 100%;
  }
`;

export default FlowHealthInformation;
